import { navContentStore } from "@phn/state/nav-content-store";
import { EventEmitter, Fragment, h } from "@stencil/core";
import { getMenuContent } from "../../../services/menu-items-service";
import {
  filterWishlistItemsByAuthStatus,
  getAvailableShopVariables,
  getIconNameByMenuItemId,
} from "@phn/utility/helper/shop-helper";
import { replaceVariables } from "../../../services/string-helper";
import { Timeout } from "@phn/utility/timeout";
import windowService from "@phn/services/window-service";
import {
  constructRoutingKey,
  RoutingKeys,
} from "@phn/entities/routing-key";
import { EventActions } from "@phn/utility/constants";
import {
  TShopAuthStatus,
  TShopMenu,
} from "@phn/entities/content";
import { navStateStore } from "@phn/state/nav-state-store";
import {
  isDesktop,
  IsLoggedIn,
  isString,
} from "@phn/utility/helper";

interface ShopSectionProps {
  activeRoutingKey: any;
  breakpoint: any;
  receivedContent: any;
  phnLogin: EventEmitter<void>;
  showWishlist: boolean;
}

export default function ShopSection(props: ShopSectionProps) {
  const eventPreventedTimeout = new Timeout(0);

  const handleLogin = (id: string) => {
    if (id === "login") {
      const phnLogin = props.phnLogin.emit();

      eventPreventedTimeout.set(() => {
        if (phnLogin.defaultPrevented) {
          return;
        }

        const loginLink = navContentStore.state.account?.link;
        if (isString(loginLink)) {
          windowService.redirectToUrl(loginLink);
          return;
        }
      });
    }
  };

  const showHeadline = !isDesktop(Number(props.breakpoint));
  const displayedContent = getMenuContent(
    navContentStore.state,
    props.activeRoutingKey,
    RoutingKeys.SHOP,
  ) as TShopMenu;

  if (displayedContent === null) {
    return <div></div>;
  }

  const wishListAuthStatusList: TShopAuthStatus[] = IsLoggedIn(
    navStateStore.state.loggedInState,
  )
    ? ["loggedIn", null]
    : ["loggedOut", null];

  const wishListItems = filterWishlistItemsByAuthStatus(
    displayedContent.additionalContent ?? [],
    wishListAuthStatusList,
  );

  return (
    <Fragment>
      <phn-nd-menu
        item={displayedContent}
        showHeadline={showHeadline}
        receivedContent={props.receivedContent}
      />
      {props.activeRoutingKey === RoutingKeys.SHOP && props.showWishlist ? (
        <div class="wishlist-container" role="list">
          {wishListItems.map((childItem) => (
            <phn-nd-menu-item
              key={childItem.id}
              data-id={childItem.id}
              size={"x-small"}
              class={
                !(isString(childItem.iconUrl) || isString(childItem.icon))
                  ? "no-icon"
                  : ""
              }
              iconLeft={
                (isString(childItem.id) &&
                  getIconNameByMenuItemId(childItem.id)) ||
                childItem.icon ||
                childItem.iconUrl
              }
              elementId={constructRoutingKey(
                props.activeRoutingKey,
                childItem.id,
              )}
              analyticsId={childItem.id}
              text={replaceVariables(
                childItem.text,
                getAvailableShopVariables(),
              )}
              link={childItem.link}
              datalayerEventAction={
                isString(childItem.link)
                  ? EventActions.NAVIGATION_LINK_CLICK
                  : EventActions.NAVIGATION_CLICK
              }
              onClick={() => {
                handleLogin(childItem.id);
              }}
              role="listitem"
            />
          ))}
        </div>
      ) : null}
    </Fragment>
  );
}
